import Module from '../types/module.type';

type Args = {
  module: Module;
};

const getRequiredLevelOptions = ({ module }: Args) => {
  switch (module) {
    case 'products':
      return [
        { value: 'PRODUCT', label: 'Product' },
        { value: 'VARIANT', label: 'Product Variant' },
      ];
    case 'inventory':
      return [
        { value: 'INVENTORY', label: 'Inventory' },
        { value: 'ATOM', label: 'Atom' },
      ];
    default:
      return [];
  }
};

export default getRequiredLevelOptions;
